import { Stack, Typography } from "~/common/mui";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

export const PasswordRequirements = ({ password }: { password: string }) => {
  const { t } = useTranslation();
  const requirements = [
    {
      label: t("onboarding.overlay.password.requirements.characters"),
      passed: password.length >= 8,
    },
    {
      label: t("onboarding.overlay.password.requirements.uppercase"),
      passed: /[A-Z]/.test(password),
    },
    {
      label: t("onboarding.overlay.password.requirements.lowercase"),
      passed: /[a-z]/.test(password),
    },
    {
      label: t("onboarding.overlay.password.requirements.number"),
      passed: /\d/.test(password),
    },
    {
      label: t("onboarding.overlay.password.requirements.specialCharacter"),
      passed: /[^A-Za-z0-9]/.test(password),
    },
  ];

  return (
    <Stack spacing={0.5} mt={1}>
      {requirements.map((item) => (
        <Stack key={item.label} direction="row" gap={1} alignItems="center">
          {item.passed ? (
            <CheckIcon sx={{ width: "12px", height: "12px", color: "primary.main" }} />
          ) : (
            <CloseIcon sx={{ width: "12px", height: "12px" }} />
          )}
          <Typography color={item.passed ? "primary.main" : "text.secondary"}>{item.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};
